import React from 'react';
import { checkDependency } from 'ui-component-library/uhmse/EpiForms/EpiForms.dependencies';
import { checkFieldActions } from 'ui-component-library/uhmse/EpiForms/EpiForms.actions';
import { Field, TextArea, Select, Multiselect, RadioButton, Checkbox, Fieldset, Button, Label, ErrorSpan, } from 'ui-component-library/base/Form';
import { Tooltip } from 'ui-component-library/base';
export var useFormRenderer = function (fields, state, dependencies, formId) {
    var invalidFields = state.invalidFields, validationMessages = state.validationMessages, isLoading = state.isLoading, values = state.values;
    var fieldActionExists = false;
    var renderFormElement = function (fieldName) {
        var field = fields[fieldName];
        var _a = fields[fieldName], name = _a.name, text = _a.text;
        var type = fields[fieldName].type;
        if (type === null) {
            type = 'text';
        }
        var renderAsFieldset = (type === 'radio' || type === 'checkbox') && field.options.length > 1;
        var singleCheckboxOrRadio = (type === 'radio' || type === 'checkbox') && field.options.length === 1;
        var fieldHasDependency = dependencies &&
            dependencies.filter(function (field) { return field.fieldName === name; }).length > 0;
        if (fieldHasDependency) {
            var fieldShouldBeRendered = checkDependency(name, dependencies, values);
            if (!fieldShouldBeRendered) {
                return;
            }
        }
        if (renderAsFieldset) {
            return React.createElement("div", { key: name }, renderFieldset(field));
        }
        else if (singleCheckboxOrRadio) {
            return (React.createElement("div", { key: name },
                renderSingleInput(field),
                renderFieldError(field.name, field.type)));
        }
        else if (type === 'ParagraphText') {
            return React.createElement("div", { key: name, dangerouslySetInnerHTML: { __html: text } });
        }
        else {
            var id = "form" + name;
            if (type === 'hidden') {
                id = "form" + name + "-" + formId;
            }
            return (React.createElement("div", { key: name, id: id },
                field.type !== 'multiselect' && renderLabel(field),
                field.type !== 'multiselect' &&
                    field.description &&
                    renderTooltip(field),
                renderField(field),
                renderFieldError(field.name, field.type)));
        }
    };
    var renderLabel = function (_a) {
        var name = _a.name, label = _a.label, required = _a.required, type = _a.type;
        if (!label || type === 'submit' || type === 'reset') {
            return null;
        }
        return (React.createElement(Label, { htmlFor: name, required: required }, label));
    };
    var renderTooltip = function (_a) {
        var label = _a.label, description = _a.description;
        return React.createElement(Tooltip, { label: label, description: description });
    };
    var renderFieldError = function (id, type) {
        var validationMessage = validationMessages[id] && validationMessages[id].message;
        var isInvalid = invalidFields.indexOf(id) !== -1;
        var fieldId = id;
        if (type === 'hidden') {
            fieldId = id + "-" + formId;
        }
        return (React.createElement(ErrorSpan, { fieldId: fieldId, invalid: isInvalid }, validationMessage));
    };
    var renderField = function (_a) {
        var name = _a.name, type = _a.type, required = _a.required, pattern = _a.pattern, placeholder = _a.placeholder, disabled = _a.disabled, description = _a.description, min = _a.min, max = _a.max, label = _a.label, failedMessage = _a.failedMessage, patternMessage = _a.patternMessage, options = _a.options, fieldActions = _a.fieldActions, text = _a.text;
        var buttonText = label || type;
        switch (type) {
            case 'submit':
            case 'reset':
                if (type === 'submit' && isLoading) {
                    buttonText = 'Loading...';
                }
                return (React.createElement(Button, { type: type, name: name, disabled: isLoading, id: name }, buttonText));
            case 'textarea':
                return (React.createElement(TextArea, { id: name, name: name, required: required, placeholder: placeholder, disabled: disabled, label: label, validationMessage: failedMessage }));
            case 'select':
                return (React.createElement(Select, { id: name, name: name, label: label, placeholder: placeholder, required: required, options: options, validationMessage: failedMessage }));
            case 'multiselect':
                return (React.createElement(Multiselect, { id: name, label: label, required: required, options: options, validationMessage: failedMessage, isInvalid: invalidFields.indexOf(name) !== -1 }));
            case 'rtetext':
                return (React.createElement("div", { className: "richtext epiforms altfont" },
                    React.createElement("div", { dangerouslySetInnerHTML: {
                            __html: text,
                        } })));
            case 'text':
            default:
                var actions = {};
                var id = name;
                if (fieldActions) {
                    actions = checkFieldActions(fieldActions, values);
                    fieldActionExists = true;
                }
                if (type === 'hidden') {
                    id = name + "-" + formId;
                }
                return (React.createElement(Field, { type: type, id: id, name: name, pattern: pattern, required: (actions && actions.required) || required, placeholder: placeholder, label: label, min: min, max: max, disabled: disabled, validationMessage: failedMessage, patternMessage: patternMessage }));
        }
    };
    var renderFieldset = function (_a) {
        var name = _a.name, type = _a.type, options = _a.options, label = _a.label, required = _a.required, description = _a.description, validationMessage = _a.validationMessage;
        var isInvalid = invalidFields.indexOf(name) !== -1;
        var FieldComponent = type === 'radio' ? RadioButton : Checkbox;
        return (React.createElement(Fieldset, { id: name, description: description, required: required, label: label, isInvalid: isInvalid, validationMessage: validationMessage }, options.map(function (opt, index) {
            return (React.createElement(FieldComponent, { id: name, index: index, key: index, name: name, value: opt.value, label: opt.caption }, opt.caption));
        })));
    };
    var renderSingleInput = function (_a) {
        var name = _a.name, type = _a.type, options = _a.options, required = _a.required, disabled = _a.disabled, description = _a.description, validationMessage = _a.validationMessage;
        var fieldLabel = options[0].caption;
        var fieldValue = options[0].value;
        var FieldComponent = type === 'radio' ? RadioButton : Checkbox;
        return (React.createElement(FieldComponent, { id: name, name: name, value: fieldValue, required: required, disabled: disabled, single: true, label: fieldLabel, validationMessage: validationMessage },
            fieldLabel,
            required && React.createElement("abbr", { title: "Obligatoriskt" }, "*")));
    };
    return [renderFormElement, fieldActionExists];
};
